import { apiClient } from './axios';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  roleId: string;
  role: {
    id: string;
    name: string;
    displayName: string;
  };
  status: 'ACTIVE' | 'INACTIVE';
  createdAt: string;
  updatedAt: string;
}

export interface Role {
  id: string;
  name: string;
  displayName: string;
  description?: string;
}

export interface CreateUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleId: string;
}

export interface UpdateUserDto {
  email?: string;
  firstName?: string;
  lastName?: string;
  roleId?: string;
  status?: 'ACTIVE' | 'INACTIVE';
}

export interface ResetPasswordDto {
  newPassword: string;
}

const unwrapResponse = <T>(responseData: any): T => responseData?.data ?? responseData;

export const usersApi = {
  getAll: async (): Promise<User[]> => {
    const response = await apiClient.get('/users');
    return unwrapResponse<User[]>(response.data);
  },

  getOne: async (id: string): Promise<User> => {
    const response = await apiClient.get(`/users/${id}`);
    return unwrapResponse<User>(response.data);
  },

  create: async (data: CreateUserDto): Promise<User> => {
    const response = await apiClient.post('/users', data);
    return unwrapResponse<User>(response.data);
  },

  update: async (id: string, data: UpdateUserDto): Promise<User> => {
    const response = await apiClient.put(`/users/${id}`, data);
    return unwrapResponse<User>(response.data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  resetPassword: async (id: string, data: ResetPasswordDto): Promise<void> => {
    await apiClient.post(`/users/${id}/reset-password`, data);
  },

  getRoles: async (): Promise<Role[]> => {
    const response = await apiClient.get('/users/roles');
    return unwrapResponse<Role[]>(response.data);
  },
};
